module.exports = __webpack_public_path__ + "img/cbdw_en.cbffead.png";